import events from '~/modules/game-events/game-events';
import { useEventEffect } from '~/modules/game-events/hooks';
import PlayersManager from '~/modules/players/players-manager';
import RemoteMicManager from '~/modules/remote-mic/remote-mic-manager';
import { RemoteMicrophoneInputSource } from '~/routes/select-input/input-sources/remote';
import { slotForMic } from '~/routes/select-input/remote-mic-slots';

export function useRemoteMicAutoselect() {
  useEventEffect(events.remoteMicConnected, ({ id }) => {
    const slot = slotForMic(
      id,
      PlayersManager.getPlayers(),
      RemoteMicManager.getRemoteMics().map((mic) => mic.id),
    );

    // Already in a slot, or every slot belongs to a phone that is still connected.
    if (slot === null) return;

    // The slot is remembered off playerInputChanged (see remote-mic/event-listeners), which this
    // fires, so a phone moved by hand afterwards is remembered the same way.
    const player = PlayersManager.getPlayer(slot) ?? PlayersManager.addPlayer(slot);
    player?.changeInput(RemoteMicrophoneInputSource.inputName, 0, id);
  });
}
